import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { drawer } from 'reducers/drawer';
import { snackbar } from 'reducers/snackbar';
import { modals } from 'reducers/modals';
import { loader } from 'reducers/loader';
import { localStorageSettings } from 'reducers/localStorageSettings';
import { overlay } from 'reducers/overlay';
import { sessionSettings } from 'reducers/sessionSettings';

import { config } from 'reducers/api/config';
import { baseStrings } from 'reducers/api/baseStrings';
import { languages } from 'reducers/api/languages';
import { localeStrings } from 'reducers/api/localeStrings';
import { users } from 'reducers/api/users';

const rootReducer = combineReducers({
  baseStrings,
  config,
  drawer,
  form: formReducer,
  languages,
  loader,
  localStorageSettings,
  modals,
  overlay,
  sessionSettings,
  snackbar,
  users,
  localeStrings
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js